import { useState } from "react";
import {StarBorderTwoTone} from '@mui/icons-material';
import { Tooltip } from "@mui/material";

export const IconPremium = () => {

    const [isTooltipOpen, setIsTooltipOpen] = useState(false)

    const handleMouseEnter = () => {
        !isTooltipOpen && setIsTooltipOpen(true)
    }

    const handleMouseLeave = () => {
        setIsTooltipOpen(false)
    }

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <Tooltip title="Premium" arrow open={isTooltipOpen} placement="bottom">
                <StarBorderTwoTone style={{ backgroundColor: '#ffffff' }} />
            </Tooltip>
        </div>
    )
}
